import { ThreadState } from './thread.state';
import { PageInfoModel } from '../../../shared/data/models/page-info.model';

export interface DmState {
  showThreads: boolean;

  loading: boolean;
  error: string;

  currentThreadID: string;
  pageInfo: PageInfoModel;
  threads: ThreadState[];
}

export const initialDmState: DmState = {
  showThreads: true,
  loading: false,
  error: '',
  currentThreadID: null,
  pageInfo: null,
  threads: []
};
